import { setup as apiSetup } from 'js-api'

apiSetup({
  baseUrl: window.config.baseUrl
})
